import { initializeApp } from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
  connectAuthEmulator,
} from "firebase/auth";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyCFx5KZOQHKSUHalxCJzbCN4LzmsMEX-8I",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "canvas-454421.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "canvas-454421",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "canvas-454421.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "834169310208",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:834169310208:web:56b9b229c334a59ed51ce5",
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || "G-0RZVR1JQF7",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

// Connect to Firebase emulator in development
if (
  import.meta.env.DEV &&
  !auth._authSettings?.emulatorHost
) {
  const emulatorHost =
    import.meta.env.VITE_FIREBASE_AUTH_EMULATOR_HOST || "localhost:9099";
  connectAuthEmulator(auth, `http://${emulatorHost}`, {
    disableWarnings: true,
  });
}

export const googleProvider = new GoogleAuthProvider();
